import { render, staticRenderFns } from "./TeacherBankAccountForm.vue?vue&type=template&id=4e4da4b2&lang=true"
import script from "./TeacherBankAccountForm.vue?vue&type=script&lang=js"
export * from "./TeacherBankAccountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports